import { RaceDefinition } from 'shared/types/erg'

// Boat/participant names and logbook_id are PII, and provide no debugging value
// beyond what lane_number/class_name/affiliation (left as-is) already give — so
// they're dropped entirely before the definition is attached to Sentry context,
// rather than sent in any form.
export function sanitizeDefinitionForSentry(definition: RaceDefinition) {
	return {
		...definition,
		boats: definition.boats.map(({ name, logbook_id, participants, ...rest }) => rest),
	}
}
